export default __webpack_public_path__ + "625be4e2a16da5ca1cb3a6701babb2cc.png";